import { Popover, Carousel } from "antd";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Remove from "./remove";
import RemoveAccount from "./removeAccount";
const backgroundImages = [
  "/source/BG_01.jpg",
  "/source/BG_02.jpg",
  "/source/BG_03.jpg",
  "/source/BG_04.jpg",
  "/source/BG_05.jpg",
];
const Index = () => {
  return (
    <div className="App">
      <Carousel autoplay>
        {backgroundImages.map((image, index) => (
          <div key={index} className="carousel-slide">
            <div
              className="carousel-slide-bg"
              style={{ backgroundImage: `url(${image})` }}
            />
          </div>
        ))}
      </Carousel>

      <div className="left">
        <div className="content">
          <div>
            <img src="././source/logo.png" alt="" className="left-logo" />
            <div className="secTitle">
              <div>Chat on Meboo,</div>
              <div>date in life</div>
            </div>
          </div>

          <div className="link">
            <a
              className="appstore"
              href="https://play.google.com/store/apps/details?id=com.kly.meboo&pli=1"
              target="_blank"
              rel="noreferrer"
            >
              <img src="././source/googleplay.png" className="img" />
            </a>

            {/* <Popover content={"Coming Soon"}> */}
              <div className="appstore">
                <img src="././source/appstore.png" className="img" />
              </div>
            {/* </Popover> */}
            {/* <a
              className="appstore"
              href="https://apps.apple.com/cn/app/id6476920897"
              target="_blank"
              rel="noreferrer"
            >
              <img src="././source/appstore.png" className="img" />
            </a> */}
          </div>

          <div className="chose">
            <div className="option">
              <a href="./terms.html" target="_blank" className="option_item">
                <img src="././source/terms.png" />
                Terms
              </a>
              <Popover content={"contact@meboo-app.com"}>
                <div className="option_item">
                  <img src="././source/help.png" />
                  Help
                </div>
              </Popover>
              <a
                href="./PrivacyPolicy.html"
                target="_blank"
                className="option_item"
              >
                <img src="././source/privacy.png" />
                PrivacyPolicy
              </a>
              <a href="./removeAccount"
                target="_blank"
                className="option_item">Account deletion</a>
            </div>
            <div className="option">
              @2023 www.imeboo-app.com
            </div>
          </div>

        </div>
      </div>
      {/* <div className="right">
        <img src="././source/spark.png" />
      </div> */}
    </div>
  );
};
const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/remove" element={<Remove />} />
      <Route path="/removeAccount" element={<RemoveAccount />} />
    </Routes>
  );
};

export default App;
